document.addEventListener('DOMContentLoaded', function() {
  // Находим все элементы с dropdown
  const dropdownItems = document.querySelectorAll('.footer__nav-item');
  let isMobile = window.innerWidth <= 768;

  // Проверка, есть ли у элемента dropdown
  function hasDropdown(item) {
    return item.querySelector('.footer__dropdown') !== null;
  }

  // Функция для переключения dropdown
  function toggleDropdown(item) {
    // Проверяем, есть ли у элемента dropdown
    if (!hasDropdown(item)) return;

    const wasActive = item.classList.contains('active');

    // Закрываем все dropdown
    closeAllDropdowns();

    // Если dropdown не был активен, открываем его
    if (!wasActive) {
      item.classList.add('active');
    }
  }

  // Функция для закрытия всех dropdown
  function closeAllDropdowns() {
    dropdownItems.forEach(item => {
      item.classList.remove('active');
    });
  }

  // Обработчик клика для мобильных
  function handleMobileClick(e) {
    e.preventDefault();
    e.stopPropagation();
    const item = this.closest('.footer__nav-item');
    toggleDropdown(item);
  }

  // Обработчик для десктопа (наведение)
  function handleDesktopMouseEnter() {
    if (!hasDropdown(this)) return;
    closeAllDropdowns();
    this.classList.add('active');
  }

  // Обработчик для десктопа (уход)
  function handleDesktopMouseLeave() {
    setTimeout(() => {
      if (!this.matches(':hover')) {
        this.classList.remove('active');
      }
    }, 100);
  }

  // Инициализация dropdown для конкретного элемента
  function initDropdownForItem(item) {
    const link = item.querySelector('.footer__nav-link');
    const dropdown = item.querySelector('.footer__dropdown');

    // Очищаем старые обработчики
    if (link) {
      link.removeEventListener('click', handleMobileClick);
    }
    item.removeEventListener('mouseenter', handleDesktopMouseEnter);
    item.removeEventListener('mouseleave', handleDesktopMouseLeave);

    // Если нет dropdown, ничего не делаем
    if (!dropdown) return;

    if (isMobile) {
      // Мобильная версия - клик для открытия/закрытия
      if (link) {
        link.addEventListener('click', handleMobileClick);
      }
    } else {
      // Десктопная версия - ховер
      item.addEventListener('mouseenter', handleDesktopMouseEnter);
      item.addEventListener('mouseleave', handleDesktopMouseLeave);
    }
  }

  // Полная инициализация всех dropdown
  function initAllDropdowns() {
    isMobile = window.innerWidth <= 768;

    dropdownItems.forEach(item => {
      initDropdownForItem(item);
    });
  }

  // Закрытие dropdown при клике вне его
  function handleOutsideClick(e) {
    if (isMobile) {
      // Проверяем, был ли клик вне dropdown элемента
      let clickedInside = false;

      dropdownItems.forEach(item => {
        if (item.contains(e.target)) {
          clickedInside = true;
        }
      });

      if (!clickedInside) {
        closeAllDropdowns();
      }
    }
  }

  // Закрытие при нажатии Escape
  function handleEscapeKey(e) {
    if (e.key === 'Escape') {
      closeAllDropdowns();
    }
  }

  // Обработка изменения размера окна
  function handleResize() {
    const newIsMobile = window.innerWidth <= 768;

    // Переинициализируем только если изменился режим (мобильный/десктоп)
    if (newIsMobile !== isMobile) {
      isMobile = newIsMobile;
      initAllDropdowns();

      // При переходе на мобильную версию закрываем все dropdown
      if (isMobile) {
        closeAllDropdowns();
      }
    }
  }

  // Оптимизация обработки resize
  let resizeTimeout;
  function debouncedResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleResize, 150);
  }

  // Инициализация всех обработчиков событий
  function initEventListeners() {
    // Клик вне dropdown
    document.addEventListener('click', handleOutsideClick);

    // Клавиша Escape
    document.addEventListener('keydown', handleEscapeKey);

    // Изменение размера окна
    window.addEventListener('resize', debouncedResize);
  }

  // Удаление всех обработчиков событий (для очистки)
  function removeEventListeners() {
    document.removeEventListener('click', handleOutsideClick);
    document.removeEventListener('keydown', handleEscapeKey);
    window.removeEventListener('resize', debouncedResize);

    dropdownItems.forEach(item => {
      const link = item.querySelector('.footer__nav-link');
      if (link) {
        link.removeEventListener('click', handleMobileClick);
      }
      item.removeEventListener('mouseenter', handleDesktopMouseEnter);
      item.removeEventListener('mouseleave', handleDesktopMouseLeave);
    });
  }

  // Основная функция инициализации
  function init() {
    console.log('Инициализация dropdown меню в футере...');

    // Проверяем, есть ли вообще dropdown элементы
    if (dropdownItems.length === 0) {
      console.log('Dropdown элементы не найдены');
      return;
    }

    // Сначала удаляем все старые обработчики
    removeEventListeners();

    // Инициализируем dropdown
    initAllDropdowns();

    // Добавляем обработчики событий
    initEventListeners();

    console.log(`Dropdown инициализированы: ${dropdownItems.length} элементов, режим: ${isMobile ? 'мобильный' : 'десктоп'}`);
  }

  // Запускаем инициализацию
  init();

  // Для отладки - экспортируем функции в глобальную область видимости
  window.footerDropdown = {
    toggleDropdown,
    closeAllDropdowns,
    initDropdowns: initAllDropdowns,
    isMobile: () => isMobile
  };
});
